import type { ReactNode } from 'react';

export const symbol_eyeglasses_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M211-320q-39 0-70.5-26T101-413L69-570q-3 0-6 .5t-7 .5q-13 1-23-7t-11-21q-1-13 7.5-22.5T51-630q69-6 113.5-8t82.5-2q65 0 104.5 5.5T418-615q15 8 30.5 11.5T480-600q15 0 30-3.5t29-10.5q28-14 70-20t113-6q45 0 91.5 2.5T910-631q13 1 21.5 10.5T939-598q-1 13-10.5 21t-22.5 7q-4 0-7.5-1t-6.5-1l-33 160q-8 41-39 66.5T750-320h-91q-39 0-69.5-25T550-408l-30-127h-78l-31 127q-9 39-39.5 63.5T302-320h-91Zm-52-105q5 20 19 32.5t32 12.5h91q19 0 33-12t18-30l35-141q-31-8-69.5-12t-70.5-4q-26 0-57.5 1t-57.5 3l27 150Zm449 2q4 19 18 31t33 12h91q18 0 32.5-12.5T801-425l29-151q-24-2-54-2.5t-54-.5q-34 0-75 4t-74 12l35 140Z"
		/>
	</svg>
);
